var BlockView = require('views/block/base-block-view');
var FeedbackService = require('services/feedback-service');
const AhoyService = require('services/ahoy-service');
import IconLoadService from 'services/icon-load-service';
import { KeybindingService, keys } from 'services/keybinding-service';
const { Enter, Space } = keys;

var HotspotView = BlockView.extend({
  className: 'hotspots',
  possibleStates: ['correct', 'incorrect'],
  findById: function (id) {
    return this.model.get('hotspots').find(hotspot => {
      return hotspot.id === id;
    });
  },

  initialize: function () {
    _.each(this.model.get('hotspots'), (hotspot, index) => {
      const index_id = index === 0 ? this.model.cid : `${this.model.cid}-${index}`;
      hotspot.index_id = index_id;
      if (typeof hotspot.header_icon_unclicked === 'object') {
        const {
          header_icon_unclicked: { name, prefix },
        } = hotspot;
        if (name && prefix) {
          IconLoadService.applyIcon(name, index_id, null, prefix);
        }
      } else {
        const { header_icon_unclicked } = hotspot;
        if (typeof header_icon_unclicked === 'string') {
          IconLoadService.applyIcon(header_icon_unclicked, index_id);
        }
      }
    });
    BlockView.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    //TODO: bootstrap popovers on hotspots?
    $('[data-toggle="popover"]').popover();
    this.renderMultipleNestedBlocks('hotspots');

    var self = this;
    let hotspotButtonSelector = '.hotspot';
    _.each(this.model.get('hotspots'), function (h) {
      h.correct = h.correct === undefined ? true : h.correct;
    });

    if (this.model.get('in_sequence')) {
      self.$el
        .find('.hotspot')
        .prop('disabled', true)
        .find('a')
        .click(e => e.preventDefault());
      $('#' + this.model.get('hotspots')[0].id).prop('disabled', false);
    }

    if (this.model.get('correct_hotspots_required') !== undefined) {
      this.hotspots_required = this.model.get('correct_hotspots_required');
    } else {
      this.hotspots_required = _.filter(this.model.get('hotspots'), function (h) {
        return h.correct;
      }).length;
    }

    this.delegate('click', 'a.back .close-btn', function (e) {
      var id = e.target.getAttribute('data-hotspot');
      self.$el.find(`#${id} a.front`).removeClass('front-hide');
      self.$el.find(`#${id} a.back`).removeClass('back-show');
      self.checkComplete();
      setTimeout(function () {
        self.$el.find(`#${id} a.front`).focus();
      }, 0);
      return false;
    });

    this.clicked_hotspots = {};

    this.delegate('click', hotspotButtonSelector, function (e) {
      if (self.model.get('dont_bubble_up')) {
        e.stopPropagation();
      }
      if (!this.$el.hasClass('any-clicked')) {
        this.$el.addClass('any-clicked');
      }
      var clicked_element = $(e.currentTarget);
      var clicked_hotspot = _.find(self.model.get('hotspots'), function (h) {
        return h.id == clicked_element.attr('id');
      });

      const completedIconPresent = this.model.get('default_icon_clicked');

      if (completedIconPresent) {
        this.addCompletedIcon(completedIconPresent);
        this.hideHeaderFromHotSpot(clicked_hotspot);
      }

      //only prevent default if the element clicked isn't in a nested block
      let blockListElement = clicked_element.find('.block-list')[0];
      let targetNested = $(e.target)
        .parents()
        .filter((i, p) => p === blockListElement);
      if (targetNested.length === 0) {
        e.preventDefault();
      }

      if (!self.clicked_hotspots[clicked_hotspot.id]) {
        self.clicked_hotspots[clicked_hotspot.id] = {
          id: clicked_hotspot.id,
          clicks: 1,
          correct: clicked_hotspot.correct,
        };
      } else {
        if (self.model.get('allow_deselecting')) {
          self.clicked_hotspots[clicked_hotspot.id].clicks = 0;
        } else {
          self.clicked_hotspots[clicked_hotspot.id].clicks++;
        }
      }

      Chaplin.mediator.publish(
        'block:values:change',
        {
          id: clicked_hotspot.id,
          clicks: self.clicked_hotspots[clicked_hotspot.id].clicks,
          value: clicked_hotspot.value,
        },
        this,
        self.pageView
      );

      AhoyService.track('hotspot', {
        action: 'change',
        id: clicked_hotspot.id,
        value: clicked_hotspot.value,
        correct: clicked_hotspot.correct,
        clicks: self.clicked_hotspots[clicked_hotspot.id].clicks,
      });

      if (self.model.get('disable_on_click')) {
        if (self.model.get('disable_on_click') === 'correct' && clicked_hotspot.correct) {
          return;
        } else if (self.model.get('disable_on_click') === 'incorrect' && !clicked_hotspot.correct) {
          return;
        } else if (self.clicked_hotspots[clicked_hotspot.id].clicks > 1) {
          return;
        }
      }
      if (self.model.get('allow_deselecting')) {
        if (clicked_element.hasClass('clicked')) {
          clicked_element.removeClass('clicked');
        } else {
          clicked_element.addClass('clicked');
        }
      } else {
        clicked_element.addClass('clicked');
      }
      self.$('.hotspot').removeClass('last-clicked');
      clicked_element.addClass('last-clicked');

      var feedbackState = clicked_hotspot.correct ? 'correct' : 'incorrect';

      if (self.model.get('set_others_on_correct') && feedbackState === 'correct') {
        this.$('.hotspot')
          .not('#' + clicked_hotspot.id)
          .addClass(self.model.get('set_others_on_correct'));
      }

      if (self.model.get('in_sequence')) {
        var next_hotspot = _.find(self.model.get('hotspots'), function (h) {
          return h.index > clicked_hotspot.index;
        });
        if (next_hotspot) {
          $('#' + next_hotspot.id).prop('disabled', false);
        }
      }

      if (!clicked_element.prop('disabled')) {
        FeedbackService.renderFeedbackWithElementState(
          clicked_hotspot.feedback,
          clicked_element,
          feedbackState,
          this.possibleStates,
          this.feedbackOptions()
        );
      }

      if (self.model) {
        if (self.model.get('disable_during_feedback') && clicked_hotspot.feedback) {
          self.lock();
          return false;
        }
        if (self.model.get('with_back')) {
          if (self.model.get('show_only_one_back')) {
            self.$el.find('.hotspot a.front').removeClass('front-hide');
            self.$el.find('.hotspot a.back').removeClass('back-show');
          }
          clicked_element.find('a.front').addClass('front-hide');
          clicked_element.find('a.back').addClass('back-show');
        }
      }
    });

    this.delegate('keydown', hotspotButtonSelector, function (e) {
      KeybindingService.with(e).bind([Enter, Space], () => {
        e.preventDefault();
        e.currentTarget.click();
      });
    });
  },

  addCompletedIcon: function (completedIconPresent) {
    let name, prefix, nodeIcon;
    if (typeof completedIconPresent === 'object') {
      name = completedIconPresent.name;
      prefix = completedIconPresent.prefix;
      nodeIcon = $(`[data-icon="${this.model.get('cid')}-${prefix} ${name}"]`);
    } else {
      name = completedIconPresent;
      nodeIcon = $(`[data-icon="${this.model.get('cid')} ${name}"]`);
    }
    const iconIsAlreadyCreated = nodeIcon.find('svg').length !== 0;
    if (!iconIsAlreadyCreated) {
      if (prefix) {
        IconLoadService.applyIcon(name, this.model.get('cid'), null, prefix);
      } else {
        IconLoadService.applyIcon(name, this.model.get('cid'));
      }
    }
  },

  hideHeaderFromHotSpot: function (hotspot) {
    $('#' + hotspot.id)
      .find('.header')
      .hide();
  },

  feedbackOptions: function () {
    return {
      completed: function () {
        if (!this.model.get('closable_back')) {
          this.checkComplete();
        }
        if (this.model.get('disable_during_feedback')) {
          this.unlock();
        }
      }.bind(this),
      noFeedback: function () {
        if (!this.model.get('closable_back')) {
          this.checkComplete();
        }
      }.bind(this),
    };
  },
  play: function () {
    if (this.hotspots_required === 0) {
      this.readyToGo();
    }
    this.model.property('selected', id => {
      let hotspot = this.findById(id);
      this.clicked_hotspots[id] = {
        id: id,
        clicks: 1,
        correct: hotspot.correct,
      };
      let hotspotElement = this.$(`#${id}`);
      hotspotElement.addClass('last-clicked');

      FeedbackService.renderFeedbackWithElementState(
        hotspot.feedback,
        hotspotElement,
        'correct',
        this.possibleStates,
        this.feedbackOptions()
      );
    });
  },
  checkComplete: function () {
    var correct_clicks = _.filter(this.clicked_hotspots, function (h) {
      return h.correct !== false && h.clicks && h.clicks >= 1;
    });

    if (correct_clicks.length >= this.hotspots_required) {
      if (this.model.get('state') !== 'completed') {
        AhoyService.track('hotspot', { action: 'completed' });
        this.readyToGo();
      }
    }
  },
  lock: function () {
    this.model.get('hotspots').forEach(h => {
      this.$(`#${h.id}`)
        .prop('disabled', true)
        .find('a')
        .click(e => e.preventDefault());
    });
  },
  unlock: function () {
    this.model.get('hotspots').forEach(h => {
      this.$(`#${h.id}`).prop('disabled', false).find('a').off('click');
    });
  },
});

module.exports = HotspotView;
